import { AppRecord } from '$tablet-app/src/app/app_library/types';

export const CAMERA_PACKAGE_NAME = 'com.sec.android.app.camera';

export const built_in_apps: AppRecord[] = [
  {
    label: 'Camera',
    package_name: CAMERA_PACKAGE_NAME,
    categories: [],
  },
  {
    label: 'Gallery',
    package_name: 'com.sec.android.gallery3d',
    categories: [],
  },
  {
    label: 'Calculator',
    package_name: 'com.sec.android.app.popupcalculator',
    categories: [],
  },
  {
    label: 'Clock',
    package_name: 'com.sec.android.app.clockpackage',
    categories: [],
  },
];
